import numeral from 'numeral';

export const keys = [
    {
        key: 'clicksL',
        label: 'Clicks',
        icon: 'pagev-view',
        yAxisID: 'y3',
    },
    {
        key: 'impressionsL',
        label: 'Impressions',
        icon: 'pagev-view',
    },
    {
        key: 'ctrL',
        label: 'Avg Ctr',
        yAxisID: 'y1',
        render: (data) => numeral(data * 100).format('0.00'),
        icon: 'search',
    },
    {
        key: 'positionL',
        label: 'Postion',
        icon: 'pagev-view',
        yAxisID: 'y2',
    },
];

export default keys;
